import React, { useState } from "react";
import { useEffect } from "react";
import Select from "react-select";
import API from "utils/API";

const NPIProviderList = ({ tenantID, selectedProvider, onSelect }) => {
  const [providerName, setProviderName] = useState("");
  const [providerOpt, setProviderOpt] = useState([]);
  const [providerLoading, setProviderLoading] = useState(false);

  useEffect(() => {
    if (providerOpt.length && !selectedProvider) {
      setProviderOpt([]);
    }
  }, [selectedProvider]);

  const handleChangeProvider = async (value) => {
    setProviderName(value);
    if (!tenantID || !value) return null;
    if (value && value.length < 3) {
      return null;
  }
    setProviderLoading(true);
    try {
      const result = await API.get(`/${tenantID}/AutoSearch/Provider/${value}`);
      if (result?.data?.length > 0) {
        setProviderOpt(result.data);
        setProviderLoading(false);
      } else {
        setProviderOpt([]);
        setProviderLoading(false);
      }
    } catch (error) {
      setProviderLoading(false);
    }
  };

  const onSelectProvider = (provider) => {
    onSelect(provider);
  };

  return (
    <Select
      className="form-field-large inner-shadow-field"
      classNamePrefix="select"
      IndicatorSeparator
      isClearable={true}
      isSearchable={true}
      isLoading={providerLoading}
      placeholder=""
      name="color"
      options={providerOpt}
      inputValue={providerName}
      value={selectedProvider}
      onInputChange={handleChangeProvider}
      onChange={onSelectProvider}
      getOptionLabel={(option) => option.description}
      getOptionValue={(option) => option.id}
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }}
      styles={{
        menu: (provided) => ({
          ...provided,
          zIndex: 99,
        }),
      }}
    />
  );
};

export default NPIProviderList;
